export default __webpack_public_path__ + "static/media/Vias.04ca60b2.svg";